import React from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * Bottom section of the Opportunity Map — one row per coaching area with
 * columns showing closed / likely / revivable / lost deal counts + the
 * recommended coaching action. Bridges "behaviour" → "money".
 */
const CoachingOutcomeTable = ({ rows = [] }) => {
  if (!rows.length) return null;
  return (
    <div className="space-y-2">
      <div>
        <h3 className="text-sm font-bold text-slate-900">Coaching → Revenue Table</h3>
        <p className="text-xs text-slate-500">Where each coaching gap is intersecting with the money.</p>
      </div>
      <div className="overflow-x-auto border border-slate-200 rounded-xl bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-[11px] uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-2 font-semibold min-w-[220px]">Coaching Area</th>
              <th className="text-right px-3 py-2 font-semibold">Demonstrated</th>
              <th className="text-right px-3 py-2 font-semibold">Opportunity</th>
              <th className="text-right px-3 py-2 font-semibold text-emerald-700">Closed</th>
              <th className="text-right px-3 py-2 font-semibold text-teal-700">Likely</th>
              <th className="text-right px-3 py-2 font-semibold text-amber-700">Revivable</th>
              <th className="text-right px-3 py-2 font-semibold text-slate-500">Lost</th>
              <th className="text-left px-4 py-2 font-semibold min-w-[260px]">Recommended Coaching Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.topic} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-2 font-semibold text-slate-800">{r.topic}</td>
                <td className="px-3 py-2 text-right tabular-nums font-semibold text-emerald-700">{r.demonstrated_pct}%</td>
                <td className="px-3 py-2 text-right tabular-nums font-semibold text-amber-700">{r.opportunity_pct}%</td>
                <td className="px-3 py-2 text-right tabular-nums text-emerald-700">{r.closed_deals}</td>
                <td className="px-3 py-2 text-right tabular-nums text-teal-700">{r.likely_closed}</td>
                <td className="px-3 py-2 text-right tabular-nums text-amber-700 font-semibold">{r.revivable_deals}</td>
                <td className="px-3 py-2 text-right tabular-nums text-slate-500">{r.lost_deals}</td>
                <td className="px-4 py-2 text-xs text-slate-700">
                  <div className="flex items-start gap-1">
                    <ArrowRight className="w-3 h-3 mt-0.5 shrink-0 text-slate-400" />
                    {r.recommended_action}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CoachingOutcomeTable;
